/**
 * Checks if a contract has a tradeable security type for stock search.
 * Returns false if secType is "IND" (index instruments).
 *
 * Index instruments are non-tradeable and should not appear
 * in stock search results for baskets and portfolios.
 */
export const isTradeableSecType = (contract: {
  secType?: string;
}): boolean => {
  const secType = (contract.secType || "").toUpperCase();
  return secType !== "IND";
};
